<script setup lang="ts">
  import { useSlots } from "vue";
  import { Text } from "@ui-kit";

  const { title } = defineProps<{ title?: string }>();

  const slots = useSlots();
</script>

<template>
  <div class="check-alarming-section">
    <slot v-if="slots.title" name="title" />
    <Text v-else font="body-medium-16">{{ title }}</Text>
    <slot />
  </div>
</template>

<style scoped>
  .check-alarming-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
</style>
